import type { IUserProfile } from "@/interfaces";
import type { MainState, AppNotification } from "./state";
import type { Store, MutationTree } from "vuex";
import type { State } from "../state";

export const mutations: MutationTree<MainState> = {
  setToken(state, payload: string) {
    state.token = payload;
    // console.log("altering setToken in state to:");
    // console.log(payload);
  },
  setLoggedIn(state, payload: boolean) {
    state.isLoggedIn = payload;
  },
  setSSOLoggedIn(state, payload: boolean) {
    // console.log("setSSOLoggedIn triggered");
    // console.log(payload);
    state.ssoLoggedIn = payload;
  },
  setLogInError(state, payload: boolean) {
    state.logInError = payload;
  },
  setUserProfile(state, payload: IUserProfile) {
    state.userProfile = payload;
  },
  setDashboardMiniDrawer(state, payload: boolean) {
    state.dashboardMiniDrawer = payload;
  },
  setDashboardShowDrawer(state, payload: boolean) {
    state.dashboardShowDrawer = payload;
  },
  addNotification(state, payload: AppNotification) {
    state.notifications.push(payload);
  },
  removeNotification(state, payload: AppNotification) {
    state.notifications = state.notifications.filter((n) => n !== payload);
  },
  setOauthConfig(state, payload: { clientId: string; authority: string }) {
    state.msalConfig = payload;
  },
};

// NOTE: because mainModule is namespaced: true, committing from inside module actions uses LOCAL mutation names.
const NS = "main/";

export const commitSetDashboardMiniDrawer = (
  store: Store<State>,
  payload: boolean,
): void => {
  store.commit(`${NS}setDashboardMiniDrawer`, payload);
};

export const commitSetDashboardShowDrawer = (
  store: Store<State>,
  payload: boolean,
): void => {
  store.commit(`${NS}setDashboardShowDrawer`, payload);
};

export const commitSetLoggedIn = (
  store: Store<State>,
  payload: boolean,
): void => {
  store.commit(`${NS}setLoggedIn`, payload);
};

export const commitSetSSOLoggedIn = (
  store: Store<State>,
  payload: boolean,
): void => {
  store.commit(`${NS}setSSOLoggedIn`, payload);
};

export const commitSetLogInError = (
  store: Store<State>,
  payload: boolean,
): void => {
  store.commit(`${NS}setLogInError`, payload);
};

export const commitSetToken = (store: Store<State>, payload: string): void => {
  store.commit(`${NS}setToken`, payload);
};

export const commitSetUserProfile = (
  store: Store<State>,
  payload: IUserProfile,
): void => {
  store.commit(`${NS}setUserProfile`, payload);
};

export const commitAddNotification = (
  store: Store<State>,
  payload: AppNotification,
): void => {
  store.commit(`${NS}addNotification`, payload);
};

export const commitRemoveNotification = (
  store: Store<State>,
  payload: AppNotification,
): void => {
  store.commit(`${NS}removeNotification`, payload);
};

export const commitSetOauthConfig = (
  store: Store<State>,
  payload: { clientId: string; authority: string },
): void => {
  store.commit(`${NS}setOauthConfig`, payload);
};
